import { useState } from "react";
import { Box, Grid, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ChatIcon from "assets/icons/chat-p.svg";
import MemberFeedbackSurveyModal from "components/v3/sharedComponents/modals/MemberFeedbackSurveyModal";
import whiteLogo from "../../../../assets/images/LogoWhite.svg";
import FooterStyles from "./Footer.styles";

const Footer = () => {
  const classes = FooterStyles();
  const theme = useTheme();
  const screenWidthIsMdOrSmaller = useMediaQuery(theme.breakpoints.down("lg"));
  const currentYear = new Date().getFullYear();
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  const contactLinks = (
    <Box
      className={classes.emailLink}
      sx={{
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap",
        gap: { lg: 4, xs: 2 },
        justifyContent: screenWidthIsMdOrSmaller ? "center" : "flex-start"
      }}
    >
      <Link
        href="mailto:navigation@genomiclife.com"
        underline="hover"
        sx={{ alignItems: "center", color: "white", display: "flex" }}
      >
        <MailOutlineIcon />
        <Typography variant="body_strong_sm_white">
          navigation@genomiclife.com
        </Typography>
      </Link>
      <Box
        component="button"
        onClick={() => setIsFeedbackOpen(true)}
        type="button"
        sx={{
          alignItems: "center",
          background: "none",
          border: "none",
          color: "inherit",
          cursor: "pointer",
          display: "flex",
          padding: 0,
          "&:hover": {
            textDecoration: "underline"
          }
        }}
      >
        <Box
          alt=""
          component="img"
          src={ChatIcon}
          sx={{ display: "block", height: 24, mr: "10px", width: 24 }}
        />
        <Typography variant="body_strong_sm_white">
          Share your feedback
        </Typography>
      </Box>
    </Box>
  );

  const wideFooter = (
    <Grid container className={classes.container}>
      <Grid
        container
        justifyContent={"space-between"}
        className={classes.bigStuff}
      >
        <Grid item>
          <img
            src={whiteLogo}
            alt={"genomic-life-logo"}
            // className={classes.logo}
          />
        </Grid>
        <Grid item>
          <Grid container direction={"column"}>
            <Typography
              variant="body_strong_white"
              className={classes.contactUs}
            >
              Contact Us
            </Typography>
            <Typography variant="body_xs_gray">
              Genomic Life has a team of Genetic Health Navigators available to
              support you.{" "}
            </Typography>
            {contactLinks}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent={"space-between"}
        alignContent={"end"}
        // className={classes.smallStuff}
      >
        <Grid item>
          <Typography variant="body_sm_gray">
            © {currentYear} Genomic Life. All rights reserved.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body_sm_gray">
            4365 Executive Drive, Ste 715, San Diego, California 92121
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );

  const narrowFooter = (
    <Grid
      container
      className={`${classes.container} ${classes.narrowContainer}`}
      direction={"column"}
      textAlign={"center"}
    >
      <Grid item>
        <img
          src={whiteLogo}
          alt={"genomic-life-logo"}
          // className={classes.logo}
        />
      </Grid>
      <Grid item>
        <Typography
          variant="body_strong_lg_white"
          className={classes.contactUs}
        >
          Contact Us
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body_sm_gray">
          Genomic Life has a team of Genetic Health Navigators available to
          support you.{" "}
        </Typography>
      </Grid>
      <Grid item className={classes.spaced}>
        {contactLinks}
      </Grid>
      <Grid item className={classes.spaced}>
        <Typography variant="body_sm_gray">
          © {currentYear} Genomic Life. All rights reserved.
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body_sm_gray">
          4365 Executive Drive, Ste 715
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body_sm_gray">
          San Diego, California 92121
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <>
      {screenWidthIsMdOrSmaller ? narrowFooter : wideFooter}
      {isFeedbackOpen ? (
        <MemberFeedbackSurveyModal
          isOpen
          onClose={() => setIsFeedbackOpen(false)}
        />
      ) : null}
    </>
  );
};

export default Footer;
